// extracted by mini-css-extract-plugin
export default {"container":"ImageBlock_container__XX8p6","img":"ImageBlock_img__js5Ud"};